import { DatePipe } from '@angular/common';
import { Component, OnInit, HostListener } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { EntityPagedRequestParameters, EntityPagedResult } from "@bndes/bndes-ux4/bndes-angular-utils";
import { BnUsuarioService } from "@bndes/bndes-ux4/bn-usuario";
// import { BnCnpjPipe } from "@bndes/bndes-ux4/pipes/cnpj";
import { BnPipeCnpj } from "@bndes/bndes-ux4/bn-mask2/cpfcnpj";
import { of } from 'rxjs';
import moment from "moment";
import { AgenteFinanceiro } from 'src/app/model/agente-financeiro.model';
import { AtualizacaoInformacoesRiscoOperacao } from 'src/app/model/atualizacao-info-risco.model';
import { STATUS_PROTOCOLO } from 'src/app/model/protocolo-arquivo.model';
import Utils from 'src/app/shared/fgi-utils';
import { FileUtilsService } from 'src/app/shared/file-utils.service';
import { PermissaoService } from 'src/app/shared/permissao.service';
import { ROLE_AGENTE_CONSULTA, ROLE_AGENTE_ENVIO, ROLE_GESTOR_CONSULTA } from '../../../constantes/permissao.constants';
import { AtualizacaoInfoRiscoService } from './atualizacao-info-risco.service';
import { ModalidadeService } from 'src/app/shared/services/modalidade.service';

@Component({
    selector: 'app-atualizacao-info-risco-pesquisa',
    templateUrl: './atualizacao-info-risco-pesquisa.component.html',
    styleUrls: ['./atualizacao-info-risco-pesquisa.component.scss'],
    standalone: false
})
export class AtualizacaoInfoRiscoPesquisaComponent implements OnInit {

  public atributosPaginacao: EntityPagedRequestParameters;
  private atributosPaginacaoComponenteListagem: EntityPagedResult<AtualizacaoInformacoesRiscoOperacao>;
  public pesquisado: boolean = false;
  public esconderPesquisa: boolean = true;
  public agentesFinanceiros: AgenteFinanceiro[];
  public atualizacoesInfoRisco: AtualizacaoInformacoesRiscoOperacao[];
  public podeEscolherAgente: boolean;
  public ehAgenteFinanceiro: boolean = false;
  public podeEnviar: boolean;
  public cnpjUsuario: string;
  public valoresStatusProtocolo = STATUS_PROTOCOLO;
  public opcoesPaginacao: number[];
  public atualizacaoForm: UntypedFormGroup = null;
  public podeListarOperacoes: boolean;
  public totalObjetosRetornados: number;
  public siglaModalidade: string;
  public agenteFinanceiro: AgenteFinanceiro;
  public nomeRelatorio: string = 'INFORMACOES_RISCO';

  constructor(private activatedRoute: ActivatedRoute,
    private atualizacaoInfoRiscoService: AtualizacaoInfoRiscoService,
    private permissaoService: PermissaoService,
    private bnUsuarioService: BnUsuarioService,
    private datePipe: DatePipe,
    private fb: UntypedFormBuilder,
    private fileUtils: FileUtilsService,
    private modalidadeService: ModalidadeService,
    private bnPipeCnpj: BnPipeCnpj) {
    this.agentesFinanceiros = this.activatedRoute.snapshot.data['agentes'];
    this.opcoesPaginacao = [10, 15, 20];

    this.atributosPaginacaoComponenteListagem = {
      page: 1,
      pageSize: this.opcoesPaginacao[0],
      pages: undefined,
      count: undefined,
      list: undefined
    };
  }

  @HostListener('window:keydown.enter', ['$event'])
  keyEvent(event: KeyboardEvent) {
    this.buscar(false,true);
  }

  ngOnInit() {
    this.permissaoService.getPermissoesUsuarioAutenticado().subscribe((resp: any) => {
      this.podeEscolherAgente = resp && resp[ROLE_GESTOR_CONSULTA];
      this.podeEnviar = resp && resp[ROLE_AGENTE_ENVIO];
      this.ehAgenteFinanceiro = resp && resp[ROLE_AGENTE_CONSULTA];

      this.atualizacaoInfoRiscoService.getTimeStampISO().subscribe((ts: any) => {
        const momentoAtual = moment(ts ? 
          Utils.dataFromISO(ts.nowDateISO) : Utils.dataCorrente()).startOf('day');

        this.atualizacaoInfoRiscoService.getJanelaAtual().subscribe((resp) => {
          this.podeListarOperacoes = resp && !momentoAtual.isBefore(moment(resp.dataInicioListagemOperacoes).startOf('day'));
          this.podeEnviar = this.podeEnviar && resp && !momentoAtual.isBefore(moment(resp.dataAbertura).startOf('day')) && !momentoAtual.isAfter(moment(resp.dataFechamento).endOf('day'));
        });
      });

      this.bnUsuarioService.usuario$.subscribe(usuario => {
        this.cnpjUsuario = usuario?.cnpj;
        this.prepararFormulario();

        if (!this.podeEscolherAgente) {
          const agente = this.atualizacaoForm.get('cnpjAgenteFinanceiro');
          agente.disable();
          agente.patchValue(this.cnpjUsuario);
        }

      });
    });

    this.setModalidadeUsuarioLogado();
  }

  mudancaPagina(novaPagina: EntityPagedResult<AtualizacaoInformacoesRiscoOperacao>) {
    this.atributosPaginacaoComponenteListagem = novaPagina;
    this.buscar(false, false);
  }

  compararPorId(item1: string, item2: string): boolean {
    return Utils.compararPorId(item1, item2);
  }

  buscar(paginaVazia: boolean, voltarPagina1: boolean) {
    this.esconderPesquisa = true;
    
    if(voltarPagina1){
      this.atributosPaginacaoComponenteListagem.page = 1;
    }

    paginaVazia = Utils.verificaPaginaVazia(this.atualizacoesInfoRisco, this.atributosPaginacaoComponenteListagem, this.totalObjetosRetornados);
    if (paginaVazia && !voltarPagina1) {
      this.atributosPaginacaoComponenteListagem.page = this.atributosPaginacaoComponenteListagem.pages;
    }

    this.atualizacaoInfoRiscoService.getAtualizacoes(this.getParams()).subscribe((resp) => {
      this.atributosPaginacaoComponenteListagem.count = resp ? resp.totalRegistrosSemPaginacao : 0;
      this.totalObjetosRetornados = this.atributosPaginacaoComponenteListagem.count;
      this.atualizacoesInfoRisco = resp.resultados;
      this.pesquisado = true;
      this.esconderPesquisa = false;
       
      paginaVazia = Utils.verificaPaginaVazia(this.atualizacoesInfoRisco, this.atributosPaginacaoComponenteListagem, this.totalObjetosRetornados);
      if (paginaVazia && !voltarPagina1) {
        this.buscar(false, true);
      }
    });
  }

  getParams() {
    const form = this.atualizacaoForm.getRawValue();
    const params: any = {}

    if (form.cnpjAgenteFinanceiro) {
      params.cnpjAgenteFinanceiro = form.cnpjAgenteFinanceiro;
    }

    if (form.sistema) {
      params.sistema = form.sistema;
    }

    if (form.idExternoOperacao) {
      params.idExternoOperacao = form.idExternoOperacao;
    }

    if (form.contrato) {
      params.contrato = form.contrato;
    }

    if (form.dataEnvioInicial) {
      params.dataEnvioInicial = this.datePipe.transform(form.dataEnvioInicial, 'yyyyMMdd');
    }

    if (form.dataEnvioFinal) {
      params.dataEnvioFinal = this.datePipe.transform(form.dataEnvioFinal, 'yyyyMMdd');
    }

    if (form.idInformacaoDeRisco) {
      params.idInformacaoDeRisco = form.idInformacaoDeRisco;
    }

    if (form.statusProtocolo) {
      params.statusProtocolo = form.statusProtocolo;
    }

    params.pagina = this.atributosPaginacaoComponenteListagem.page;
    params.limite = this.atributosPaginacaoComponenteListagem.pageSize;

    return params;
  }

  downloadOperacoesQuePrecisamSerInformadas() {
    let cnpjAgenteFinanceiro = this.getParams().cnpjAgenteFinanceiro;
    if (cnpjAgenteFinanceiro) {
      
      this.setAgenteFinanceiro(cnpjAgenteFinanceiro);

      this.atualizacaoInfoRiscoService.getOperacoesQuePrecisamSerAtualizadas(cnpjAgenteFinanceiro).subscribe((resp) => {
        let csv = `${this.cnpjSiglaAgenteFinanceiro(cnpjAgenteFinanceiro)}\n ${this.siglaModalidade}\n ${this.formatarData(resp.dataHoraExecucao)}\nidOperacaoAgenteCreditoLivre;sistemaRepasse;contratoRepasse\n`;
  
        for (let operacao of resp.operacoes) {
          csv += (operacao.idOperacaoAgenteCreditoLivre || '') + ";" + (operacao.sistemaRepasse || '') + ";" + (operacao.contratoRepasse || '') + "\n";
        }

        this.fileUtils.exportarArquivo(`${cnpjAgenteFinanceiro}_${this.siglaModalidade}_${this.nomeRelatorio}.csv`,
        csv, FileUtilsService.TEXT_CSV);
      });
    }
    else {
      this.atualizacaoInfoRiscoService.getOperacoesQuePrecisamSerAtualizadasTodosAgentes().subscribe((resp) => {
        let csv = "cnpjAgenteFinanceiro;idOperacaoAgenteCreditoLivre;sistemaRepasse;contratoRepasse;riscoOperacao;liquidada\n";
  
        for (let operacao of resp.operacoes) {
          csv += (operacao.cnpjAgenteFinanceiro || '') + ";" + (operacao.idOperacaoAgenteCreditoLivre || '') + ";" + (operacao.sistemaRepasse || '') + ";" + (operacao.contratoRepasse || '') + ";" + (operacao.riscoOperacao || '') + ";" + (operacao.liquidada || '') + "\n";
        }

        this.fileUtils.exportarArquivo(`CONSOLIDADO_${this.siglaModalidade}_${this.nomeRelatorio}.csv`,
        csv, FileUtilsService.TEXT_CSV);
      });
    }
  }

  limpar() {
    this.atualizacaoForm.reset();

    if (!this.podeEscolherAgente) {
      const agente = this.atualizacaoForm.get('cnpjAgenteFinanceiro');
      agente.disable();
      agente.patchValue(this.cnpjUsuario);
    }

    this.pesquisado = false;
  }

  criarFormulario(): UntypedFormGroup {

    const form = this.fb.group({
      cnpjAgenteFinanceiro: null,
      sistema: '',
      contrato: [null, [Validators.pattern(/^[0-9]+$/), Validators.minLength(11), Validators.maxLength(11)]],
      idExternoOperacao: [null, [Validators.pattern(/^[A-Za-z0-9_\-]+$/), Validators.minLength(1), Validators.maxLength(20)]],
      dataEnvioInicial: null,
      dataEnvioFinal: null,
      idInformacaoDeRisco: null,
      statusProtocolo: null
    });

    form.get('sistema').valueChanges.subscribe(sistema => {
      const contrato = form.get('contrato');
      const idExterno = form.get('idExternoOperacao');

      switch (sistema) {
        case '':
          idExterno.enable();
          contrato.enable();
          idExterno.reset();
          contrato.reset();
          break;
        case 'CL':
          idExterno.enable();
          contrato.reset();
          contrato.disable();
          break;
        default:
          contrato.enable();
          idExterno.reset();
          idExterno.disable();
          break;
      }

      idExterno.updateValueAndValidity();
      contrato.updateValueAndValidity();
    });

    return form;
  }

  prepararFormulario() {
    const pesquisaSalva = of(JSON.parse(sessionStorage.getItem('atualizacaoInfoRiscoPesquisa')));

    if (!this.atualizacaoForm) {
      this.atualizacaoForm = this.criarFormulario();
    }

    pesquisaSalva.subscribe(formulario => this.preencherFormulario(formulario))

    this.atualizacaoForm.valueChanges.subscribe(values => {
      sessionStorage.setItem('atualizacaoInfoRiscoPesquisa', JSON.stringify(values));
      this.pesquisado = false;
    })
  }

  preencherFormulario(model: any): void {

    this.atualizacaoForm.patchValue({
      cnpjAgenteFinanceiro: model?.cnpjAgenteFinanceiro || null,
      sistema: model?.sistema || '',
      contrato: model?.contrato || null,
      idExternoOperacao: model?.idExternoOperacao || null,
      dataEnvioInicial: model?.dataEnvioInicial || null,
      dataEnvioFinal: model?.dataEnvioFinal || null,
      idInformacaoDeRisco: model?.idInformacaoDeRisco || null,
      statusProtocolo: model?.statusProtocolo || null
    });
  }

  setModalidadeUsuarioLogado() {
    this.modalidadeService.modalidade$.subscribe({
      next: (response) => {
        this.siglaModalidade = response;
      },
      error: () => {
        this.siglaModalidade = '';
        console.log('Não foi possível obter a sigla da modalidade que o usuário está logado.');
      }
    })
  }

  setAgenteFinanceiro(cnpj_: string) {
    this.agenteFinanceiro = this.agentesFinanceiros.filter(af => af.cnpj === cnpj_)[0];
  }

  cnpjSiglaAgenteFinanceiro(cnpj_): string {
    let cnpj = this.bnPipeCnpj.transform(cnpj_);
    let siglaAf = this.agenteFinanceiro?.sigla;
    return `${cnpj}-${siglaAf}`;
  }

  formatarData(data: string | number | Date) {
    return data ? this.datePipe.transform(data, 'dd/MM/yyyy HH:mm') : '';
  }

}